<dx-popup
    title="Service Address"
    [width]="600"
    [height]="'95%'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-scroll-view>
        <dx-form [formData]="serviceAddress" [colCount]="2" validationGroup="serviceAddressValidationGroup">
            <dxi-form-item [label]="{ text: 'Address Lookup' }" [colSpan]="2">
                <div *dxTemplate>
                    <app-address-lookup (onLocationChanged)="locationChanged($event)"></app-address-lookup>
                </div>
            </dxi-form-item>

            @if (mode === 'range') {
                <dxi-form-item [label]="{ text: 'Range' }" [colSpan]="2">
                    <div *dxTemplate>
                        <dx-radio-group
                            [dataSource]="ranges"
                            [(value)]="serviceAddress.range"
                            layout="horizontal"
                            (onValueChanged)="radioButtonChanged($event)"
                        >
                        </dx-radio-group>
                    </div>
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                </dxi-form-item>
            }
            @if (mode === 'zone') {
                <dxi-form-item [label]="{ text: 'Zone' }" [colSpan]="2">
                    <div *dxTemplate>
                        <dx-radio-group
                            [dataSource]="zones"
                            [(value)]="serviceAddress.zone"
                            layout="horizontal"
                            (onValueChanged)="radioButtonChanged($event)"
                        >
                        </dx-radio-group>
                    </div>
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                </dxi-form-item>
            }

            <dxi-form-item dataField="siteName" [label]="{ text: 'Name' }" [colSpan]="2"></dxi-form-item>
            <dxi-form-item dataField="address1" [colSpan]="2"></dxi-form-item>
            <dxi-form-item dataField="address2" [colSpan]="2"></dxi-form-item>
            <dxi-form-item dataField="city"></dxi-form-item>
            <dxi-form-item dataField="state"></dxi-form-item>
            <dxi-form-item dataField="zip"></dxi-form-item>
            <dxi-form-item dataField="county"></dxi-form-item>
            <dxi-form-item dataField="latitude"></dxi-form-item>
            <dxi-form-item dataField="longitude"></dxi-form-item>
            <dxi-form-item dataField="phone" [colSpan]="2"></dxi-form-item>
            <dxi-form-item [label]="{ text: 'Site Notes' }" [colSpan]="2">
                <div *dxTemplate>
                    <dx-text-area [(value)]="serviceAddress.notes" [height]="'100px'"></dx-text-area>
                </div>
            </dxi-form-item>
            <dxi-form-item dataField="distance" [disabled]="true"></dxi-form-item>
            <dxi-form-item>
                <div *dxTemplate>
                    <button class="btn btn-primary mt-2" (click)="setDistance()">Set</button>
                </div>
            </dxi-form-item>

            <dxi-form-item itemType="group" caption="Matching Rate" [colCount]="2" [colSpan]="2">
                <dxi-form-item [label]="{ text: 'Rate' }">
                    <div *dxTemplate>
                        <dx-text-box [(value)]="rateTypeDisplay" [disabled]="true"></dx-text-box>
                    </div>
                </dxi-form-item>
                <dxi-form-item itemType="empty"></dxi-form-item>
                <dxi-form-item [label]="{ text: 'Base Rate' }">
                    <div *dxTemplate>
                        <dx-text-box [(value)]="baseRateDisplay" [disabled]="true"></dx-text-box>
                    </div>
                </dxi-form-item>
                <dxi-form-item itemType="empty"></dxi-form-item>
                <dxi-form-item [label]="{ text: 'Price/Ton Rate' }">
                    <div *dxTemplate>
                        <dx-text-box [(value)]="pricePerTonDisplay" [disabled]="true"></dx-text-box>
                    </div>
                </dxi-form-item>
                <dxi-form-item>
                    <div *dxTemplate>
                        <button class="btn btn-sm btn-success mt-2" (click)="addCustomerRate()" [disabled]="selectedCustomerRate">
                            Add Rate
                        </button>
                    </div>
                </dxi-form-item>
            </dxi-form-item>
        </dx-form>
    </dx-scroll-view>
</dx-popup>
